import { Endpoint } from "@rest-hooks/endpoint";
export function isErrorFromSearch(res) {
    const e = res;
    return e.title != null || e.detail != null;
}
export const performContractSearch = async (data) => {
    return fetch(`/changeCustomer/search?${data.searchType}=${encodeURIComponent(data.needle)}${data.typeOfChange ? "&typeOfChange=" + data.typeOfChange : ""}`, { method: "post" }).then(async (res) => {
        return await res.json();
    });
};
export const ContractSearchEndpoint = new Endpoint(performContractSearch, {
    key(data) {
        return `contract-search ${data.searchType} ${data.needle}`;
    },
    dataExpiryLength: 1000
});
//# sourceMappingURL=ContractSearch.js.map